/**
 * Idle Cash Report (FSD Part 3 3.2.4.10, R043; follow-up #80).
 *
 * The wiring packet spreads `TREASURY_IDLE_CASH_ROUTES` into the router and adds
 * the nav item described by `TREASURY_IDLE_CASH_NAV` to section s-3.2.4.
 *
 * Gated on `treasury.kpi.read`, the permission `GET /reports/idle-cash`
 * declares. The path is a literal string (the conformance deep-link parser
 * cannot read a constant).
 */

import type { RouteRecordRaw } from 'vue-router'

import { IDLE_CASH_PERMISSIONS } from '@/modules/treasury/reports/idle-cash/permissions'

export const TREASURY_IDLE_CASH_PATH = '/treasury/reports/idle-cash'

/** For the wiring packet: the nav item to add (p03-treasury.ts, s-3.2.4). */
export const TREASURY_IDLE_CASH_NAV = {
  id: 'treasury-idle-cash',
  section: 's-3.2.4',
  fsd: '3.2.4',
  code: 'R043',
  to: '/treasury/reports/idle-cash',
  labelKey: 'treasury.idleCash.nav.label',
  descriptionKey: 'treasury.idleCash.nav.description',
  permission: IDLE_CASH_PERMISSIONS.read,
} as const

export const TREASURY_IDLE_CASH_ROUTES: RouteRecordRaw[] = [
  {
    path: '/treasury/reports/idle-cash',
    name: 'treasury-idle-cash',
    component: () => import('@/modules/treasury/reports/idle-cash/IdleCashView.vue'),
    meta: {
      titleKey: 'treasury.idleCash.routeTitle',
      permission: IDLE_CASH_PERMISSIONS.read,
    },
  },
]
